import { InvalidArgumentError } from '@uploadcam/common';
import { PaymentResult, PaymentResultStatus } from '../models/payment-result.model';

export class GetPaymentResultInteractor {
  public execute(url: URL): PaymentResult {
    const searchParams = url.searchParams;
    const priceId = searchParams.get('priceId');
    const status = searchParams.get('redirect_status') as PaymentResultStatus;

    if (!priceId || !status) {
      throw new InvalidArgumentError();
    }

    return new PaymentResult(priceId, status);
  }
}
